'use strict';

angular.module('app').factory('ScenariosService', ScenariosService);

ScenariosService.$inject = ['ApiService', 'ModalService'];

function ScenariosService(ApiService, ModalService) {
    return {
        import: function () {
            return ApiService.get('api/super/gettemptoken').then(function (res) {
                    return res;
                }, function (err) {
                    return err;
                }
            );
        },
        export: function (e) {
            return ApiService.post('api/super/scenarios/export', e.target.result).then(function (res) {
                    ModalService.alert('CSV file is uploaded.', 'Success');
                    return res;
                }, function (err) {
                    return err;
                }
            );
        }
    };
}

